export function getDomain() {
  const matches = location.hostname.match(/[^\.]*\.[^.]*$/);

  // for localhost
  if (!matches) return location.hostname + ";";

  return matches[0] + ";";
}
